import axios from "axios";

import { EntityKind } from "models/entityKind";

import { IGroupByListColumn, IGroupByListItem } from "../../../models";
import { fetchGeomBins } from "./fetchGeomBins";

const rootUrl = process.env.REACT_APP_COLUMN_SET_SERVICE;

const GeomBinPrefix = "GeomBin";
const OrgDefinedColumnPropertyPrefix = "Org_Focus_Fields";

export const fetchOrgDefinedColumns = async (
  entityKind: EntityKind = EntityKind.Well
): Promise<IGroupByListItem> => {
  try {
    let orgList = null;

    const orgDefinedColumnsResponse = await axios.get(
      `${rootUrl}/org-defined-columns?entityKind=${entityKind.toString()}`
    );

    if (orgDefinedColumnsResponse.status === 200) {
      orgList = orgDefinedColumnsResponse.data;
    }

    if (orgList && entityKind === EntityKind.Well) {
      const columns = (await fetchGeomBins("isOrg=true")).map((bin) => {
        return {
          title: bin.name,
          id: bin.id,
          canBin: false,
          dataType: "Text",
          canNormalize: false,
          group: GeomBinPrefix,

          subgroup: bin.group,
          property: `${OrgDefinedColumnPropertyPrefix}_${GeomBinPrefix}_${btoa(
            bin.group
          )}_${bin.id}`,
          fieldType: "geom",
          withinSubgroupOrder: bin.withinSubGroupOrder
        } as IGroupByListColumn;
      });

      orgList.columns = orgList.columns.concat(columns);
    }

    return orgList;
  } catch {
    //ignore
  }
};
